import { TPnpCashierContent } from '../models/pnpCashier.ts';
import { findOne } from '../payload/client.ts';

const COLLECTION = 'pnp_cashier';

type TPayloadPnpCashier = {
  header?: string | null;
  title?: string | null;
  description?: string | null;
  placeholder?: string | null;
  cta_label?: string | null;
  terms_text?: string | null;
  suggested_amounts?: { amount: string }[] | null;
};

export const getPnpCashierContent = async (
  language: string,
): Promise<TPnpCashierContent | undefined> => {
  const content = await findOne<TPayloadPnpCashier>(COLLECTION, { locale: language });

  if (!content) {
    return undefined;
  }

  return {
    header:           content.header ?? undefined,
    title:            content.title ?? undefined,
    description:      content.description ?? undefined,
    placeholder:      content.placeholder ?? undefined,
    ctaLabel:         content.cta_label ?? undefined,
    termsText:        content.terms_text ?? undefined,
    suggestedAmounts: (content.suggested_amounts ?? [])
      .map(({ amount }) => Number(amount))
      .filter((amount) => amount > 0),
  };
};
